import React from 'react'
import $ from 'jquery'
import "./Styles/Projects.css"
export default function Projects() {
    $(document).ready(()=>{
        $(".container-flex").fadeIn(2000)

        $(".box1").hover(()=>{
            $(".box1>h1").fadeIn();
        },()=> {
            $(".box1>h1").fadeOut();
        });

        $(".box2").hover(()=>{
            $(".box2>h1").fadeIn();
        },()=> {
            $(".box2>h1").fadeOut();
        });

        $(".box3").hover(()=>{
            $(".box3>h1").fadeIn();
        },()=> {
            $(".box3>h1").fadeOut();
        });

    })
    const img_wrap1 = {
        background:"url('./Images/project_images/tasties.png') no-repeat center",
        
    }
    const img_wrap2 = {
        background:"url('./Images/project_images/rumdonemovies.png') no-repeat center",
        
    }
    const img_wrap3 = {
        background:"url('./Images/project_images/proxysearch.png') no-repeat center",
        
    }
    return (
       
    <div className="container-flex ">
        <br/><br/>
         <div className="intro col-sm-12 col-md-8 mx-auto">
             <h1>My Projects</h1>
             <p className="">Below are some of my current and finished projects.
                All of my projects use React as a
                frontend and NodeJS/serverless backends. Check them out!</p>
         </div>
        <br/><br/>
        <br/><br/>

     
        <div className="row mb-5">
            <div className=" w-50 mx-auto " >
            <div style={img_wrap1} className="box box1 shadow">
                <h1 className="display-3 bg-white" ><a href="https://dev6636.d3efg0hik4r4k1.amplifyapp.com"><b>Go to live Site </b></a></h1>    
            </div><br/>
            <h1>Tasties</h1>
            <hr className="w-50"/>
            <p className="p-3 ">Local Sports Bar offering Tasty Foods, Snacks, drinks and beverages </p>
            <p className="text-center ">Tech Stack</p>
            <div className="d-inline ">
                <img className="m-1"src="./Images/icons/javascript_icon.svg" alt=""/>
                <img className="m-1"src="./Images/icons/bootstrap_icon.svg" alt=""/>
                <img className="m-1"src="./Images/icons/react_icon.svg" alt=""/>
            
            </div>

        </div>
        </div>
        <div className="row mb-5">
            <div className=" w-50 mx-auto " >
            <div style={img_wrap2} className="box box2 shadow">
                <h1 className="display-3 bg-white" ><a target="_blank" href="http://dpcores.com/movies"><b>Go to live Site </b></a></h1>      
            </div><br/>
            <h1>Rumdone Movies</h1>
            <hr className="w-50"/>
            <p className="">Collection of movies and shows connected to Gdrive API  </p>
            <p className="text-center ">Tech Stack</p>
            <div className="d-inline ">
                <img className="m-1"src="./Images/icons/gdrive.svg" alt=""/>
                <img className="m-1"src="./Images/icons/bootstrap_icon.svg" alt=""/>
                <img className="m-1"src="./Images/icons/nodejs.svg" alt=""/>
            
            </div>

        </div>
        </div>
        <div className="row mb-5">
            <div className=" w-50 mx-auto " >
            <div style={img_wrap3} className="box box3 shadow">
                <h1 className="display-3 bg-white" ><a target="_blank" href="http://usproxies.dpcores.com/visual"><b>Go to live Site </b></a></h1>      
            </div><br/>
            <h1>Proxy Search</h1>
            <hr className="w-50"/>
            <p className="">Proxy search using Python Beautiful Soup scraping backend and google maps api </p>
            <p className="text-center ">Tech Stack</p>
            <div className="d-inline ">
                <img className="m-1"src="./Images/icons/google_maps.svg" alt=""/>
                <img className="m-1"src="./Images/icons/python.svg" alt=""/>
                <img className="m-1"src="./Images/icons/react_icon.svg" alt=""/>
            
            </div>

        </div>
        </div>
    </div>
    )
}
